/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Calendar, Flag } from "react-feather";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { Activities } from "../../components/Activities";
import AlertList from "../../components/AlertList";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import Filemanager from "../../components/FileManager";
import TaskList from "../../components/TaskList";
import useFetcher from "../../hooks/useFetcher";
import { fetchNovedad } from "../../services/novedadesServices";
import { novedadUtil } from "../../utils/novedadUtil";
import Observations from "./Observations";
import { useAuth } from "../../context/AuthContext";
import modulos from "../../mocks/modulos";

const NovedadDetail = ({ match, history }) => {
  const { currentUser } = useAuth();
  const isAudit = currentUser.haveAuditAccess(modulos.CALENDAR);
  const itemId = match.params.id;
  const [tasks, setTasks] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [novedad, isLoading] = useFetcher(fetchNovedad, [itemId]);
  const activityComponent = useRef();
  const objNovedad = novedadUtil(novedad);
  const status = objNovedad.statusStr();
  const colorClass = objNovedad.statusColorClass(status);
  const [selectedTabKey, setSelectedTabKey] = useState("observation");
  const [selectedNovedadTabKey, setSelectedNovedadTabKey] = useState("tareas");

  const handleChangeRefreshActivity = () => {
    activityComponent.current.refreshActivities();
  };

  const onTasksChange = () => {
    handleChangeRefreshActivity();
  };

  const onAlertsChange = () => {
    handleChangeRefreshActivity();
  };

  const handleTabsChange = (key) => {
    setSelectedTabKey(key);
  };

  const handleNovedadTabsChange = (key) => {
    setSelectedNovedadTabKey(key);
  };

  useEffect(() => {
    if (novedad.tareas) {
      novedad.tareas.map((item) => {
        if (item.class.id === 1) {
          setTasks((prev) => [...prev, item]);
        }
        if (item.class.id === 2) {
          setAlerts((prev) => [...prev, item]);
        }
      });
    }
  }, [novedad]);

  const handleBack = () => {
    history.goBack();
  };

  return (
    <>
      {novedad.cliente && (
        <Helmet>
          <title>PIN - {novedad.cliente.razonSocial}</title>
        </Helmet>
      )}
      {novedad.cliente && (
        <Breadcrumb
          title={`${novedad.cliente.razonSocial} ${novedad.cliente.numeroDeLegajo.replace(".0000", "").padStart(7, 0)}`}
          parent="Sistema de Recordatorios"
          backButton
          onBackButton={handleBack}
        />
      )}
      <BlurSpinner isLoading={isLoading}>
        <Container fluid>
          <Row>
            <Col lg="8" className="pb-3">
              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody className="row justify-content-center text-center">
                      <Col md="3">
                        <div className={`body ${colorClass}`}>
                          <Flag />
                          <h4>
                            <span
                              className="badge"
                              style={{
                                fontSize: "unset",
                              }}
                            >
                              {status}
                            </span>
                          </h4>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Calendar style={{ color: "var(--orange)" }} />
                          <h4>{novedadUtil(novedad).startDateFormatted()}</h4>
                          <p>Inicio</p>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Calendar style={{ color: "var(--yellow)" }} />
                          <h4>{novedadUtil(novedad).endDateFormatted()}</h4>
                          <p>Fin</p>
                        </div>
                      </Col>
                      <Col md="3">
                        <div className="body">
                          <Calendar style={{ color: "var(--teal)" }} />
                          <h4>{novedadUtil(novedad).resolveDateFormatted()}</h4>
                          <p>Resolución</p>
                        </div>
                      </Col>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg="12">
                  <Row className="pb-0 pt-3 pt-lg-0">
                    <Col>
                      <Card className="h-100 mb-0">
                        <Tabs activeKey={selectedNovedadTabKey} onSelect={handleNovedadTabsChange}>
                          <Tab eventKey="tareas" title="Tareas">
                            <TaskList tasks={tasks} setTasks={setTasks} novedadId={novedad.id} onChange={onTasksChange} withPaging withClientData={false} />
                          </Tab>
                          <Tab eventKey="alertas" title="Alertas">
                            <AlertList alerts={alerts} setAlerts={setAlerts} novedadId={novedad.id} onChange={onAlertsChange} withPaging withClientData={false} />
                          </Tab>
                        </Tabs>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col lg="4" className="pb-3">
              <div className="h-50 mb-0 pb-3">
                <Activities
                  ref={activityComponent}
                  bodyStyle={{ overflow: "auto", maxHeight: "320px" }}
                  entityId={itemId}
                  entity="novedad"
                  hideHeader
                  editable={!isAudit}
                />
              </div>
              <div className="h-50 mb-0 pt-3">
                <Tabs activeKey={selectedTabKey} onSelect={handleTabsChange}>
                  <Tab eventKey="observation" title="Observaciones">
                    {novedad.id && <Observations novedad={novedad} isAudit={isAudit} />}
                  </Tab>
                  <Tab eventKey="filemanager" title="Archivos">
                    <Filemanager
                      bodyStyle={{ overflow: "auto", maxHeight: "246px" }}
                      entityId={itemId}
                      entity="novedad"
                      onChange={handleChangeRefreshActivity}
                      disclaimer
                      editable={!isAudit}
                    />
                  </Tab>
                </Tabs>
              </div>
            </Col>
          </Row>
        </Container>
      </BlurSpinner>
    </>
  );
};

export default withRouter(NovedadDetail);
